const BACKEND_PORT = 9090;

/**
 * Resolve the backend API base URL.
 *
 * Staging/prod set REACT_APP_BACKEND_API_URL explicitly (the API lives on its own
 * domain, e.g. https://api.prod.pitchler.com), so an explicit value always wins.
 *
 * In our local FlowStream dev it's left empty, so we derive the base from the
 * page's own host on the backend's port (9090). That way a single build works
 * whether the career site is reached directly (http://10.0.8.20:3000 -> :9090) or
 * through an SSH tunnel (http://localhost:3000 -> :9090) — no hardcoded host.
 */
export function getApiBase(): string {
  const env = process.env.REACT_APP_BACKEND_API_URL;
  if (env) return env;
  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.hostname
  ) {
    return `${window.location.protocol}//${window.location.hostname}:${BACKEND_PORT}`;
  }
  return `http://localhost:${BACKEND_PORT}`;
}
